import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

type Step = { title: string; body: string };

const STEPS: ReadonlyArray<Step> = [
  {
    title: 'Vous nous écrivez',
    body: "Un message sur WhatsApp ou le formulaire ci-dessous. Dis-nous ton type de commerce et ce que tu veux voir en priorité.",
  },
  {
    title: 'Démo live 20-30 min',
    body: 'Appel visio ou WhatsApp avec un vrai compte Velko. On part de ton catalogue si tu en as un, sinon on utilise un exemple proche de ton activité.',
  },
  {
    title: 'Essai gratuit 14 jours',
    body: "Tu gardes le compte utilisé pendant la démo, sans carte bancaire. On reste disponible pour t'accompagner pendant les deux premières semaines.",
  },
];

export default function DemoStepsSectionV2() {
  return (
    <section className="bg-paper py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <SectionLabel>Comment ça se passe</SectionLabel>
        <h2 className="mt-3 max-w-2xl font-marketing-display text-[clamp(30px,4.4vw,56px)] font-bold leading-[1.02] tracking-[-0.035em] text-charcoal-800">
          Trois étapes. <span className="underline-lime">Zéro engagement.</span>
        </h2>

        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {STEPS.map((step, i) => (
            <div
              key={step.title}
              className="flex flex-col gap-4 border-2 border-charcoal-800 bg-white p-7 shadow-neobrutal-4"
            >
              <span
                className="flex h-10 w-10 shrink-0 items-center justify-center border-2 border-charcoal-800 bg-lime-500 font-marketing-display text-[18px] font-bold text-charcoal-800"
                aria-hidden="true"
              >
                {i + 1}
              </span>
              <h3 className="font-marketing-display text-[19px] font-bold leading-[1.18] tracking-[-0.01em] text-charcoal-800">
                {step.title}
              </h3>
              <p className="font-marketing-body text-[14px] leading-[1.55] text-charcoal-600">
                {step.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
